/** The views a workbench side panel switches between. */
export enum SidePanelTab {
	Workbench = 'workbench',
	Evidence = 'evidence',
}
